import { render, staticRenderFns } from "./Logos.vue?vue&type=template&id=74481c67&scoped=true&"
var script = {}
import style0 from "./Logos.vue?vue&type=style&index=0&id=74481c67&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74481c67",
  null
  
)

export default component.exports